import React, { forwardRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import classes from './LoadingWidget.module.scss';

// interface Props {
// 	state: object;
// }

const LoadingWidget = forwardRef((_, ref) => {
	return (
		<div ref={ref} tabIndex={-1} className={classes.CircularProgressContainer}>
			<CircularProgress />
		</div>
	);
});

LoadingWidget.displayName = 'LoadingWidget';

export default LoadingWidget;
